import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/hotels/[country-slug]/[city-slug]/[area-slug]/components/HotelAreaLevelGroupComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/hotels/[country-slug]/SwiperStyle.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/hotels/components/HotelSearchBoxForSeoComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useTranslation"] */ "/app/src/app/i18n/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/BreadcrumbComponent/BreadcrumbComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getPromotionData"] */ "/app/src/libs/client/goApi/promotion/getPromotionData.tsx");
